export default "/static/oko_chamber_tiny.png";